import script from "./QuestionPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionPicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__